// extracted by mini-css-extract-plugin
export default {"chatFile_Attach":"ChatFileAttach_chatFile_Attach__ooozF","chatFile_Attach_HasFiles":"ChatFileAttach_chatFile_Attach_HasFiles__CPTTY","clipIcon":"ChatFileAttach_clipIcon__WD+Ez"};